// balanceReducer.js
import { FETCH_BALANCE, FETCH_BALANCE_ERROR } from '../types';

const initialState = {
  loading: true,
  error: null,
  exchanges: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_BALANCE:
      return {
        ...state,
        loading: false,
        error: null,
        exchanges: action.payload || [],
      };

    case FETCH_BALANCE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        exchanges: [],
      };

    default:
      return state;
  }
}
